import { useEffect } from 'react';
import { useCustomQuery } from './apollo/ApolloCustomHooks';
import { IAppSetting } from '../interfaces/AppSetting';
import { EnumsValues, SettingBooleanString } from '../enums/EnumsValues';
import { Query } from '../services/graphql/query';

export function useAppMultitenant(): boolean {
  const { data, error } = useCustomQuery<{ getAppSettingByKey: IAppSetting }>(
    Query.getAppSettingByKey,
    { variables: { input: { key: EnumsValues.SettingNames.MultiTenant } } },
  );

  useEffect(() => {
    if (error) console.error('App.multitenant', error);
  }, [error]);

  return data?.getAppSettingByKey?.setting_value === SettingBooleanString.True;
}
